var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.772 1.725c.355.355.61.796.742 1.28.754 3.038.58 7.835.014 10.99a2.872 2.872 0 0 1-2.022 2.022c-1.773.483-8.908.483-8.908.483s-7.136 0-8.908-.483a2.873 2.873 0 0 1-2.022-2.022C-.092 10.97.117 6.17.653 3.02A2.872 2.872 0 0 1 2.675.998C4.448.515 11.583.5 11.583.5s7.136 0 8.909.484c.484.13.926.386 1.28.741ZM15.232 8.5l-5.92 3.428V5.071l5.92 3.429Z",
    fill: "#0F1125"
  })));
};
export default SvgYoutube;